export class SipRow {
  constructor({
    id = 0,
    quantity = 0,
    extension = 0,
    extensionName = null,
    contractLength = 0,
    ratePlanID = 0,
    ani = null,
    saved = false
  } = {}) {
    this.id = id;
    this.extension = extension;
    this.extensionName = extensionName;
    this.contractLength = contractLength;
    this.ratePlanID = ratePlanID;
    this.ani = ani;
    this.saved = saved;
    this.quantity = quantity;
  }
}
export function createNewSipRow(data) {
  return Object.freeze(new SipRow(data));
}
